import { render, staticRenderFns } from "./PRJ305M02.vue?vue&type=template&id=120db1a8&"
import script from "./PRJ305M02.vue?vue&type=script&lang=js&"
export * from "./PRJ305M02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports